"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const lucide_vue_next_1 = require("lucide-vue-next");
const AgronomicInsightRankTag_vue_1 = __importDefault(require("@becrop/components/Results/AreaProjectMap/Components/AgronomicInsights/AgronomicInsightRankTag.vue"));
const MicroorganismsPanel_vue_1 = __importDefault(require("@becrop/components/Results/AreaProjectMap/Components/Microorganisms/MicroorganismsPanel.vue"));
const parcel_1 = __importDefault(require("@becrop/components/Results/DistroTool/controllers/services/parcel"));
const ColorLibController_1 = __importDefault(require("@becrop/components/Results/Abstract/Controllers/ColorLibController"));
let AgronomicInsightsPanel = class AgronomicInsightsPanel extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.filteredFieldsAgInsights = this.metricAgInsights;
        this.fieldToSearch = '';
        this.controllerColor = new ColorLibController_1.default();
    }
    get fieldActiveReactive() {
        return this.fieldActiveKey;
    }
    updateFieldActiveKey(f) {
        this.$emit('updateFieldActiveKey', f);
    }
    get internal_theme() {
        if (this.theme)
            return this.theme;
        return this.$theme.current.value;
    }
    get hasMicroorganismsPanel() {
        if (this.metric.microorganisms.length > 0 && this.metric.category === 'HLT' && this.metric.scale === 'hlt')
            return true;
        return false;
    }
    metricByField(field, metric) {
        let metricCurrent;
        field.results_stats.metrics.forEach((metricField) => {
            if (metricField.metric_code === metric.code_name) {
                metricCurrent = metricField;
            }
        });
        return metricCurrent;
    }
    onSearchField(f) {
        this.filteredFieldsAgInsights = this.metricAgInsights.filter((a) => a.field.name.toLowerCase().includes(f.toLowerCase()));
        if (this.filteredFieldsAgInsights.length === 1) {
            this.updateFieldActiveKey(`${this.filteredFieldsAgInsights[0].field.name}${this.filteredFieldsAgInsights[0].field.id}`);
        }
    }
    dismissInsight() {
        this.$emit('dismissInsight');
    }
    parcelSvg(polygon) {
        return (0, parcel_1.default)(polygon, 32, 32);
    }
    buildSVGColor(field, metric) {
        const avg = this.metricByField(field, metric).stats.mean;
        let style = '';
        this.metric.scale === 'hlt'
            ? style =
                `stroke: ${this.generateColoRankHLT(this.controllerColor.getRankFromScore(avg))};
                fill: ${this.generateColoRankHLT(this.controllerColor.getRankFromScore(avg))}50;`
            : style =
                `stroke: ${this.generateColoRank(this.controllerColor.getRankFromScore(avg))};
                fill: ${this.generateColoRank(this.controllerColor.getRankFromScore(avg))}50;`;
        return style;
    }
    generateColoRank(rank) {
        let myRank = rank;
        if (myRank === 0)
            myRank = 1;
        return this.controllerColor.getRankColor(myRank.toString());
    }
    generateColoRankHLT(rank) {
        let myRank = rank;
        if (myRank === 0)
            myRank = 1;
        return this.controllerColor.getDiseasesColor(myRank.toString());
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], AgronomicInsightsPanel.prototype, "metric", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], AgronomicInsightsPanel.prototype, "metricAgInsights", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], AgronomicInsightsPanel.prototype, "mainProjectDelivery", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: null })
], AgronomicInsightsPanel.prototype, "theme", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], AgronomicInsightsPanel.prototype, "displayMetricInfo", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], AgronomicInsightsPanel.prototype, "fieldActiveKey", void 0);
AgronomicInsightsPanel = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: { PencilIcon: bmk_ui_framework_1.PencilIcon, RankTag: AgronomicInsightRankTag_vue_1.default, Button: bmk_ui_framework_1.Button, XAloneIcon: bmk_ui_framework_1.XAloneIcon, XDiamondIcon: bmk_ui_framework_1.XDiamondIcon, X: lucide_vue_next_1.X, Loading: bmk_ui_framework_1.Loading, Search: bmk_ui_framework_1.Search, MicroorganismsPanel: MicroorganismsPanel_vue_1.default },
    })
], AgronomicInsightsPanel);
exports.default = AgronomicInsightsPanel;
